module.exports = __webpack_public_path__ + "img/main_banner_01.b6d9bc3.jpg";